module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "part",
    attrs: {
      "id": "p01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PART ONE")]), _c('br'), _vm._v("THE IMPRINT A BODY MAKES")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9780312374648_L02.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Even in the valley of the shadow of death, two and two do not make six.")])]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEO TOLSTOY")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-270aa2f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780312374648_epub_p01_r1.vue
// module id = 75
// module chunks = 0